import React from 'react';
import {
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import Highcharts from 'highcharts';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import HighchartsReact from 'highcharts-react-official';
import { useRef } from 'react';
import { useState } from 'react';
import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../../Components/ExpandedModal';

const color = [
	'#032E45',
	'#012935',
	'#00212E',
	'#001A27',
	'#00131F',
	'#000C18',
	'#000511',
	'#00020A',
	'#000003',
	'#000000',
];
const HeatMap = ({ chartTitle, isParent, chartheight, chartData }) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state } = useChartContext();
	const { topStatesLoading } = state;

	const options = {
		chart: {
			type: 'treemap',
			height: chartheight,
			animation: false,
		},
		colorAxis: {
			minColor: '#FFFFFF',
			maxColor: '#032E45',
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},
		plotOptions: {
			series: {
				shadow: false,
				animation: false,
			},
		},
		series: [
			{
				layoutAlgorithm: 'squarified',
				data: chartData,
			},
		],
		animation: false,

		colors: color,
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
						disabled={chartData.length === 0}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>

			{topStatesLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact
								highcharts={Highcharts}
								options={{
									...options,
									tooltip: {
										shared: true,
										useHTML: true,
										backgroundColor: 'rgba(255,255,255, 0.9)',
										borderWidth: 0,
										borderRadius: 2,
										outside: true,
										formatter: function() {
											const { point } = this;
											return renderToString(
												<Tooltip
													tooltipData={point?.tooltip}
													color={point?.color}
												/>
											);
										},
									},
								}}
								ref={chartRef}
							/>
						</>
					)}
					{isExpandedView && (
						<ExpandedModal
							heading={chartTitle}
							show={chartData.length !== 0}
							handleClose={() => setIsExpandedView(state => !state)}
						>
							<HeatMap chartheight={'30%'} chartData={chartData} />
						</ExpandedModal>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(HeatMap);
